import { render, staticRenderFns } from "./main-text-banner.vue?vue&type=template&id=4e3e6cc4&scoped=true&"
import script from "./main-text-banner.vue?vue&type=script&lang=js&"
export * from "./main-text-banner.vue?vue&type=script&lang=js&"
import style0 from "./main-text-banner.vue?vue&type=style&index=0&id=4e3e6cc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3e6cc4",
  null
  
)

export default component.exports